export default "__VITE_ASSET__B7Jm8uxA__"